// @flow

import { useStrict } from "mobx";

import "app/App";

import Render from "app/Render";

import User from "app/models/User";

import AppearanceStore from "app/stores/AppearanceStore";
import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import UserStore from "app/stores/UserStore";

import SignupView from "./app/views/app/auth/Signup/SignupView";

import TrendingView from "app/views/app/video/Trending/TrendingView";
import WatchView from "app/views/app/video/Watch/WatchView";
import NewVideoView from "app/views/app/video/NewVideo/NewVideoView";

import DashboardIndexView from "app/views/app/dashboard/DashboardIndex/DashboardIndexView";
import DashboardPreferencesView from "app/views/app/dashboard/DashboardPreferences/DashboardPreferencesView";
import DashboardPasswordView from "app/views/app/dashboard/DashboardPassword/DashboardPasswordView";
import GlobalSettingsView from "app/views/app/global/Settings/GlobalSettingsView";
import UserProfileView from "app/views/app/user/UserProfile/UserProfileView";

import AdminUsersView from "app/views/app/admin/Users/AdminUsersView";
import AdminVideosView from "app/views/app/admin/Videos/AdminVideosView";

import PasswordForm from "app/components/PasswordForm/PasswordForm";
import VideoSearchHomePage from "app/components/VideoSearchHomePage/VideoSearchHomePage";
import EditAvatar from "app/components/EditAvatar/EditAvatar";

import NavbarContainer from "app/containers/NavbarContainer";
import NotificationsContainer from "app/containers/NotificationsContainer";
import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";
import VideoCardCarousel from "app/components/VideoCardCarousel/VideoCardCarousel";
import VideoSearchContainer from "app/containers/VideoSearchContainer";
import FolderListContainer from "./app/containers/FolderListContainer";

import "./index.scss";

// Enable MobX strict mode
useStrict(true);



// Log in
window["setReactUser"] = (data: any) => UserStore.setUser(User.make(data));
window["setGlobalSettings"] = (globalSettings: { [_: string]: any }) =>
    GlobalSettingsStore.setAll(globalSettings);
window["setReactTheme"] = (theme: string) => AppearanceStore.setTheme(theme);
window["setReactHideThumbnails"] = (hide: any) =>
    AppearanceStore.hideThumbnails(hide);
window["setReactEmbed"] = (embed: any) => AppearanceStore.setEmbed(embed);

// Bind views
Render.bindView("signup", SignupView);

Render.bindView("watch", WatchView);
Render.bindView("trending", TrendingView);
Render.bindView("new-video", NewVideoView);
Render.bindView("global-settings", GlobalSettingsView);
Render.bindView("user-profile", UserProfileView);
Render.bindView("dashboard-index", DashboardIndexView);
Render.bindView("dashboard-preferences", DashboardPreferencesView);
Render.bindView("dashboard-password", DashboardPasswordView);

Render.bindView("admin-users", AdminUsersView);
Render.bindView("admin-videos", AdminVideosView);

// Bind components
Render.bindComponent("user-thumbnail", UserThumbnail);
Render.bindComponent("password-form", PasswordForm);
Render.bindComponent("notifications-container", NotificationsContainer);
Render.bindComponent("navbar-container", NavbarContainer);
Render.bindComponent("video-search-container", VideoSearchContainer);
Render.bindComponent("video-card-carousel", VideoCardCarousel);
Render.bindComponent("video-search-homepage", VideoSearchHomePage);
Render.bindComponent("folder-list", FolderListContainer);
Render.bindView("edit-avatar", EditAvatar);

// On load
document.addEventListener("DOMContentLoaded", () => Render.renderAll());



// WEBPACK FOOTER //
// ./src/index.js